import React, { useEffect, useState } from "react";
import "./styles.css"; // Custom styles for the app
import { Home } from "./home";

const App = () => {
  return <Home />;
};

export default App;
